export type SoilImprover = 'low' | 'high';

//! this is a fake type, replace it with the real one;
//! if a new one is not provide by the march 2026, remove it and all the references to it
export type AdditionalParameters = 'bar' | 'foo';

export type SoilImproverAdditionalParameter = {
  key: 'soil_improver';
  values: SoilImprover[];
};

export type ExtraAdditionalParameter = {
  key: 'additional_params';
  values: AdditionalParameters[];
};

export type PracticeAdditionalParameter =
  | SoilImproverAdditionalParameter
  | ExtraAdditionalParameter;

export type SelectedParameters = Record<
  PracticeAdditionalParameter['key'],
  PracticeAdditionalParameter
>;

export enum RequirementsKeyPracticeVerification {
  ALTERNATIVE = 'alternative',
  QDC_DECLARATION = 'qdc_declaration',
  ATTACH_RECEIPT_COVER_CROP = 'attach_receipt_cover_crop',
  ATTACH_IMAGE_COVER_CROP = 'attach_image_cover_crop',
  ATTACH_IMAGE_OVER_SEEDING = 'attach_image_over_seeding',
  ATTACH_RECEIPT_SEEDS = 'attach_receipt_seeds',
  ATTACH_RECEIPT_TRANSPORT = 'attach_receipt_transport',
  MACHINERY_SELECTION_MANURE_INPUT = 'machinery_selection_manure_input',
  ATTACH_RECEIPT_SUBCONTRACTOR = 'attach_receipt_subcontractor',
  MACHINERY_SELECTION_DIRECT_SEEDING = 'machinery_selection_direct_seeding',
  ATTACH_VIDEO_DIRECT_SEEDING = 'attach_video_direct_seeding',
  ATTACH_IMAGE_POLLINATOR_STRIPS = 'attach_image_pollinator_strips',
  ATTACH_IMAGE_GRASSED_INTER_ROW = 'attach_image_grassed_inter_row',
  ATTACH_IMAGE_MULCHING = 'attach_image_mulching',
  MACHINERY_SELECTION_MULCHING = 'machinery_selection_mulching',
  ATTACH_VIDEO_MINIMUM_TILLAGE = 'attach_video_minimum_tillage',
  MACHINERY_SELECTION_MINIMUM_TILLAGE = 'machinery_selection_minimum_tillage',
  MACHINERY_SELECTION_SLURRY_INPUT = 'machinery_selection_slurry_input',
  MACHINERY_SELECTION_POULTRY_MANURE_INPUT = 'machinery_selection_poultry_manure_input',
  ATTACH_IMAGE_CROP_ROTATION = 'attach_image_crop_rotation',
  ATTACH_IMAGE_STRIP_TILLAGE = 'attach_image_strip_tillage',
  MACHINERY_SELECTION_STRIP_TILLAGE = 'machinery_selection_strip_tillage',
  ATTACH_VIDEO_GREEN_MANURING = 'attach_video_green_manuring',
  ATTACH_IMAGE_CONSOCIATION = 'attach_image_consociation',
  ATTACH_DOCUMENTATION_GRAZING = 'attach_documentation_grazing',
  ATTACH_RECEIPT_PLANTS = 'attach_receipt_plants',
  ATTACH_IMAGE_AGROFORESTY = 'attach_image_agroforesty',
  ATTACH_IMAGE_CROP_RESIDUALS = 'attach_image_crop_residuals',
  ATTACH_RECEIPT_PRODUCT = 'attach_receipt_product',
  ATTACH_CERTIFICATION_PRODUCT = 'attach_certification_product',
}

export type RequirementManualVerification = {
  required: boolean;
  key: RequirementsKeyPracticeVerification;
  optionsAlternative?: RequirementManualVerification[];
};

export enum PracticeType {
  MANUAL = 'MANUAL',
  SATELLITE = 'SATELLITE',
  SATELLITE_MAN = 'SATELLITE_MAN',
}

export class RegenerativePractice {
  additionalParameters: PracticeAdditionalParameter[] = [];
  companyId: number = null;
  companyIdCreated: number = null;
  dateCreated: number = null;
  id: string = null;
  imgUrl: string = null;
  isRequired?: boolean = false; // optional variable used by the FE to render the currect UI
  lastModify: string = null;
  manualVerification: boolean = false;
  name: string = null;
  requirementsManualVerification: RequirementManualVerification[] = [];
  satelliteVerification: boolean = false;
  selected?: boolean = false; // optional variable used by the FE to render the currect UI
  type: PracticeType = null;
}
